import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Avatar,
  Typography,
  Box,
} from "@mui/material";
import {
  formatDateTime,
  checkMobile,
  getCategoryColor,
} from "../../../utils/utils";
import { getMediaUrl } from "../../../context/api-v1/api";

export default function ArticleListRender({ blogList, page, search }) {
  const navigate = useNavigate();
  const is_phone = checkMobile();

  const fullWidth = window.innerWidth;
  let style;
  if (is_phone) {
    style = {
      display: "flex",
      flexDirection: "column",
      marginTop: "20px",
      ml: 0,
    };
  } else {
    style = {
      display: "flex",
    };
  }

  function handleChooseArticle(v, page, search) {
    let url_ = `/blogs?blogID=${v.id}&page=${page}`;
    if (search) {
      url_ = `/blogs?blogID=${v.id}&page=${page}&search=${search}`;
    }

    navigate(url_, {
      state: {
        blogUrl: v.target,
        blogID: v.id,
        page: page,
        search: search,
        title: v.title,
      },
    });
    window.scrollTo(0, 0); // 页面归顶部, 去除首页操作时的滑动距离
  }

  return (
    <Grid
      container
      spacing={3}
      sx={{
        ...style,
        alignItems: "stretch",
      }}
    >
      {blogList
        ? is_phone
          ? blogList.map((v, i) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "10vh",
                    borderBottom: "1px dotted black",
                  }}
                  onClick={() => handleChooseArticle(v, page, search)}
                  key={i}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      mb: "7px",
                    }}
                  >
                    {v.category ? (
                      <Box
                        sx={{
                          bgcolor: getCategoryColor(v.category.content),
                          padding: "3px 0px",
                          borderRadius: "10px",
                          mr: "10px",
                          minWidth: "60px",
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          sx={{ fontWeight: "700", fontSize: "0.6rem" }}
                        >
                          {v.category.content}
                        </Typography>
                      </Box>
                    ) : (
                      ""
                    )}
                    <Typography sx={{ fontWeight: "700" }}>
                      {v.title}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{ fontSize: "0.5rem", ml: "5px", color: "#898989" }}
                  >
                    {formatDateTime(new Date(v.created_at))},&nbsp;
                    {v.author.username}
                  </Typography>
                </Box>
              );
            })
          : blogList.map((v, i) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={4}
                  xl={fullWidth > 1700 ? 3 : 4}
                  key={i}
                  sx={{ minWidth: "200px", minHeight: "200px", display: "flex" }}
                >
                  <Card
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <CardMedia
                      component="img"
                      src={
                        v.avatar
                          ? getMediaUrl(v.avatar.content)
                          : "/static/image/demo.png"
                      }
                      sx={{ cursor: "pointer", height: "19vh" }}
                      onClick={() => handleChooseArticle(v, page, search)}
                    />
                    <CardContent
                      sx={{
                        padding: "10px !important",
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="div"
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "center",
                          display: "flex",
                          marginBottom: "5px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: v.title.length >= 10 ? "16px" : "18px",
                            height: "30px",
                            lineHeight: "30px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            WordBreak: "keep - all",
                          }}
                        >
                          {v.is_private ? "🔐" : ""}
                          {v.title}
                        </Typography>
                        <Box
                          sx={{
                            // height: "30px",
                            // lineHeight: "30px",
                            alignItems: "center",
                            display: "flex",
                            textAlign: "center",
                          }}
                        >
                          {v.category ? (
                            <span
                              style={{
                                backgroundColor: "rgb(255 127 127)",
                                color: "white",
                                padding: "0 10px",
                                borderRadius: "4px",
                                marginRight: "3px",
                                fontSize: "12px",
                                fontWeight: "500",
                                height: "1.5vh",
                                minHeight: "15px",
                                lineHeight: "16px",
                                minWidth: "25px",
                                maxHeight: "40px",
                                display: "inline-block",
                              }}
                            >
                              {v.category.content}
                            </span>
                          ) : (
                            ""
                          )}
                          {v.tags
                            ? v.tags.map((v1, i) => {
                                return (
                                  <span
                                    style={{
                                      backgroundColor: "#b2b1b1",
                                      color: "white",
                                      padding: "0 10px",
                                      borderRadius: "4px",
                                      marginRight: "3px",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      height: "1.5vh",
                                      minHeight: "15px",
                                      lineHeight: "16px",
                                      minWidth: "25px",
                                      maxHeight: "40px",
                                      display: "inline-block",
                                    }}
                                    key={i}
                                  >
                                    {v1.content}
                                  </span>
                                );
                              })
                            : ""}
                        </Box>
                      </Typography>
                      <Typography
                        variant="body1"
                        component="div"
                        sx={{
                          fontSize: "10px",
                          color: "#8d8d8dde",
                          lineHeight: "16px",
                          height: "32px",
                          overflow: "hidden",
                        }}
                      >
                        {v.description}
                      </Typography>
                      <Grid
                        container
                        sx={{
                          justifyContent: "space-between",
                          marginTop: "auto",
                          paddingTop: "5px",
                        }}
                      >
                        <Grid item>
                          <Grid container alignItems="center">
                            <Grid item>
                              <Avatar
                                sx={{
                                  marginRight: 1,
                                  width: 22,
                                  height: 22,
                                  bgcolor: "skyblue",
                                }}
                                src="/static/image/avatar.jpg"
                              >
                                H
                              </Avatar>
                            </Grid>
                            <Grid item>
                              <Typography
                                variant="body1"
                                sx={{ fontSize: "13px" }}
                              >
                                {v.author.username}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="body1"
                            sx={{ fontSize: "13px", marginTop: "4px" }}
                          >
                            {formatDateTime(new Date(v.created_at))}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })
        : ""}
    </Grid>
  );
}
